import useDocumentHead from '../../hooks/useDocumentHead';
import { useLang } from '../../i18n';
import HeroSection from './sections/HeroSection';
import TrustBarSection from './sections/TrustBarSection';
import ServicesGridSection from './sections/ServicesGridSection';
import ProcessSection from './sections/ProcessSection';
import ApproachSection from './sections/ApproachSection';
import PartnersSection from './sections/PartnersSection';
import BlogTeaserSection from './sections/BlogTeaserSection';
import FaqSection from './sections/FaqSection';
import CtaSection from './sections/CtaSection';
import './HomePage.scss';

export default function HomePage() {
  const { t } = useLang();

  useDocumentHead({
    title: `${t('brand.name')} — ${t('brand.tagline')}`,
    description: t('brand.desc'),
    canonical: 'https://ukam.uz/',
    og: {
      title: `${t('brand.name')} — ${t('brand.tagline')}`,
      description: t('brand.desc'),
      type: 'website',
      url: 'https://ukam.uz/',
    },
  });

  return (
    <>
      <HeroSection />
      <TrustBarSection />
      <ServicesGridSection />
      <ProcessSection />
      <ApproachSection />
      <PartnersSection />
      <BlogTeaserSection />
      <FaqSection />
      <CtaSection />
    </>
  );
}
